import React from 'react';
import styles from '../style.module.scss';
import { useSelector } from 'react-redux';
import { RootState } from '@Redux/detail/store';
import { Gallery } from '@lion-design/liontravel';
import domainByEnv from '@utils/domainByEnv';

const Carousel: React.FC = () => {
    const { ImgMList } = useSelector((state: RootState) => state.itinerariesReducer);
    const defaultImg = `${domainByEnv()}/_webassets/lightspeed/subsitebundles/common/imgs/BBC/default-BBC.jpg`;

    //切割圖片網址
    const imgAry = ImgMList ? ImgMList.split('_,') : [];
    const isLoop = imgAry.length > 1 ? true : false;

    return ImgMList ? (
        <div className={styles.slideshow}>
            <Gallery
                picData={imgAry} //圖片路徑
                heightRate={0.5625} //寬高比例
                // pageSize={ImgMList.length}
                //縮略圖數
                defaultImg={defaultImg}
                //默認圖
                imgAlt={[]} //img alt 陣列
                imgTitle={[]} //img title 陣列
                lazyload={false} //默認false
                autoPlayDuration={3} //單位秒
                effect="scrollx"
                loop={isLoop}
                showNav={false}
                countPic={true}
                showArrow={false} //是否需要箭頭
            />
            <p>※景點照片以實際狀況為主，圖片僅提供參考。</p>
        </div>
    ) : (
        <div className={styles.defaultImg}>
            <img src={defaultImg} alt="預設圖" />
        </div>
    );
};

export default Carousel;
